import { ColCateg } from '../models/ITable';

export const PAGE_DIR = {
    PREV: 'prev',
    NEXT: 'next',
} as const;

export type PageDir = (typeof PAGE_DIR)[keyof typeof PAGE_DIR];

/**
 * Takes an array of columns and returns an object with the default columns names as { [column]: true }.
 */
export const getDefaultColsObj = (colCategs: ColCateg[]): Record<string, true> => {
    const defaultCols = colCategs
        .flatMap(categ => categ.values)
        .reduce((acc, curr) => (curr?.defaultCol ? { ...acc, [curr.value]: true } : acc), {});

    return defaultCols;
};
